export const GET_FISCALREQUIREMENTS = 'GET_FISCALREQUIREMENTS';
export const GET_FISCALREQUIREMENTS_SUCCESS = 'GET_FISCALREQUIREMENTS_SUCCESS';
export const GET_FISCALREQUIREMENTS_ERROR = 'GET_FISCALREQUIREMENTS_ERROR';
export const POST_FISCALREQUIREMENTS = 'POST_FISCALREQUIREMENTS';
export const POST_FISCALREQUIREMENTS_SUCCESS = 'POST_FISCALREQUIREMENTS_SUCCESS';
export const POST_FISCALREQUIREMENTS_ERROR = 'POST_FISCALREQUIREMENTS_ERROR';
export const UPDATE_FISCALREQUIREMENTS = 'UPDATE_FISCALREQUIREMENTS';
export const UPDATE_FISCALREQUIREMENTS_SUCCESS = 'UPDATE_FISCALREQUIREMENTS_SUCCESS';
export const UPDATE_FISCALREQUIREMENTS_ERROR = 'UPDATE_FISCALREQUIREMENTS_ERROR';
